import Html from "@/lib/Html"

export default {
  methods: {
    isScreen(screen) {
      return Html.isScreen(screen);
    },

    scrollToTop() {
      this.$scrollTo("#app");
    },
  },
}
